module.exports = __webpack_public_path__ + "static/media/3.7a165c76.png";